import React from 'react';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import { FDAlert } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

export const KYCIntroStepLayout = () => {
  const { resource, consumeAttr } = useMetaLayoutContext();
  return (
    <PageContentContainer>
      <PageContentTop
        resource={resource}
        title={consumeAttr('title')}
        subtitle={consumeAttr('description')}
      />
      <FDAlert
        title={consumeAttr('calloutTitle')}
        description={consumeAttr('calloutDescription')}
        status="info"
      />
      <MetaLayoutRemainingFields />
    </PageContentContainer>
  );
};
